import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Rectangle = forwardRef<SVGSVGElement | null, IconFilledProps>(function Rectangle({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M20.0001 7.25C20.0001 7.11193 19.8881 7 19.7501 7H4.25C4.11193 7 4 7.11193 4 7.25V16.75C4 16.8881 4.11193 17 4.25 17H19.7501C19.8881 17 20.0001 16.8881 20.0001 16.75V7.25ZM21.5001 16.75C21.5001 17.7165 20.7166 18.5 19.7501 18.5H4.25C3.2835 18.5 2.5 17.7165 2.5 16.75V7.25C2.5 6.2835 3.2835 5.5 4.25 5.5H19.7501C20.7166 5.5 21.5001 6.2835 21.5001 7.25V16.75Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          d='M21.5001 16.75C21.5001 17.7165 20.7166 18.5 19.7501 18.5H4.25C3.2835 18.5 2.5 17.7165 2.5 16.75V7.25C2.5 6.2835 3.2835 5.5 4.25 5.5H19.7501C20.7166 5.5 21.5001 6.2835 21.5001 7.25V16.75Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'rectangle-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Rectangle;
